namespace Matrix.Visualizer {
    export enum ChildrenFilter {
        NoChildren = 0,
        ImmediateChildren = 1,
        AllDescendants = 2
    }
    Serenity.Decorators.registerEnumType(ChildrenFilter, 'Matrix.Visualizer.ChildrenFilter');
}
